module.exports = __webpack_public_path__ + "img/banner-微信.4ce0632a.svg";